import css from "styled-jsx/css";

export default css`
  .teletipo-container{
    margin-top:0.7rem;
    .teletipo-content{
      display: flex;
      align-items: center;
      gap: 1rem;
      .icon{
        display: flex;
      }
    }
  }
  .alert {
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 10px;
    padding: 10px;
    :global(.buttonx) {
      padding: 0 2px;
      background-color: transparent !important;
      border-color: transparent !important;
    }
    &.justify-content-center {
      justify-content: center;
    }
    .icon {
      margin-right: 0;
    }
    .image {
      width: 20px;
      margin-right: 20px;
    }

    .icon-user {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 35px;
      width: 35px;
      background-color: white;
      border-radius: 50%;
      margin-right: 0.625rem;
    }
  }
`;